var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-nav-item-dropdown', {
    staticClass: "dropdown-user",
    attrs: {
      "right": "",
      "toggle-class": "d-flex align-items-center dropdown-user-link"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-sm-flex d-none user-nav"
        }, [_c('p', {
          staticClass: "user-name font-weight-bolder mb-0"
        }, [_vm._v(" " + _vm._s(_vm.userData.fullName || _vm.userData.username) + " ")]), _c('span', {
          staticClass: "user-status"
        }, [_vm._v(_vm._s(_vm.getTitleRole(_vm.userData.role)))])]), _c('b-avatar', {
          attrs: {
            "size": "40px",
            "variant": "light-primary",
            "text": _vm.userData.fullName ? _vm.getAbreviate(_vm.userData.fullName.split(' ')[0], _vm.userData.fullName.split(' ')[1]) : ''
          }
        }, [!_vm.userData.fullName ? _c('feather-icon', {
          attrs: {
            "icon": "UserIcon",
            "size": "22"
          }
        }) : _vm._e()], 1)];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'pages-account-setting'
      },
      "link-class": "d-flex align-items-center"
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "size": "16",
      "icon": "SettingsIcon"
    }
  }), _c('span', [_vm._v("Conta")])], 1), _c('b-dropdown-item', {
    attrs: {
      "link-class": "d-flex align-items-center"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "size": "16",
      "icon": "LogOutIcon"
    }
  }), _c('span', [_vm._v("Sair")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }